<div class="container" [attr.data-testid]="ELEMENT_IDS['cnt']">
  <div class="header" [attr.data-testid]="ELEMENT_IDS['cnt_header']" routerLink="/" style="cursor: pointer" (click)="toggleDrawer()">
    <div class="left">
      <div class="logo-container">
        <img
          src="assets/images/escience-logo-1.png"
          alt="Escience login logo"
        />
      </div>
      <div class="title-container">
        <h6 class="title" i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">eScience</h6>
        <h6 class="sub-title" i18n [attr.data-testid]="ELEMENT_IDS['lbl_sub_title']">WMS PEZA</h6>
      </div>
    </div>
    <div class="version-container">
      <h6 class="sub-title" [attr.data-testid]="ELEMENT_IDS['lbl_version']">{{ appVersion }}</h6>
    </div>
  </div>

  <!-- Main Modules -->
  <div class="division">
    <h6 i18n>MAIN MENU</h6>
  </div>
  <div class="route-container main-container" [attr.data-testid]="ELEMENT_IDS['cnt_main_menu']">
    <mat-accordion>
      @for (mainRoute of routesData; track mainRoute){
      <mat-nav-list>
        <!-- Single route -->
        @if(isSingleRoute(mainRoute)){
        <mat-list-item
          [routerLink]="mainRoute.path"
          routerLinkActive="active-link"
          class="menu-item single-route"
          (click)="toggleDrawer()"
          [attr.data-testid]="ELEMENT_IDS['nav_item'] + '_' + mainRoute.path"
        >
          <div class="item-container">
            <mat-icon>{{ mainRoute.metaData?.navIcon }}</mat-icon>
            <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_nav_item'] + '_' + mainRoute.path">{{ mainRoute.metaData?.navName }}</h6>
          </div>
        </mat-list-item>
        }
      </mat-nav-list>

      <!-- Grouped route -->
      @if(isGroupedRoute(mainRoute)){
      <mat-expansion-panel>
        <mat-expansion-panel-header [attr.data-testid]="ELEMENT_IDS['sec_panel'] + '_' + mainRoute.path">
          <mat-panel-title class="menu-item">
            <div class="item-container">
              <mat-icon>{{ mainRoute.metaData?.navIcon }}</mat-icon>
              <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_panel'] + '_' + mainRoute.path">{{ mainRoute.metaData.navName }}</h6>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          @for(childRoute of mainRoute.children; track childRoute){
          <mat-list-item
            class="menu-item"
            [routerLink]="mainRoute.path + '/' + childRoute.path + '/'"
            routerLinkActive="active-link"
            (click)="toggleDrawer()"
            [attr.data-testid]="ELEMENT_IDS['nav_item'] + '_' + mainRoute.path + '_' + childRoute.path"
          >
            <div class="item-container-second-child">
              <!-- <div class="icon-second-child-container">
                <mat-icon>circle</mat-icon>
              </div> -->
              <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_nav_item'] + '_' + mainRoute.path + '_' + childRoute.path">{{ childRoute.metaData.navName }}</h6>
            </div>
          </mat-list-item>
          }
        </mat-nav-list>
      </mat-expansion-panel>
      }

      <!-- Group Containing Group Routes -->
      @if(isMultiGroupedRoute(mainRoute)){
      <mat-expansion-panel>
        <mat-expansion-panel-header [attr.data-testid]="ELEMENT_IDS['sec_panel'] + '_' + mainRoute.path">
          <mat-panel-title class="menu-item">
            <div class="item-container">
              <mat-icon>{{ mainRoute.metaData?.navIcon }}</mat-icon>
              <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_panel'] + '_' + mainRoute.path">{{ mainRoute.metaData.navName }}</h6>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @for (innerMainRoute of mainRoute.children; track innerMainRoute){

        <mat-nav-list>
          @if(isSingleRoute(innerMainRoute)){
          <mat-list-item
            [routerLink]="innerMainRoute.path"
            routerLinkActive="active-link"
            class="menu-item"
            (click)="toggleDrawer()"
            [attr.data-testid]="ELEMENT_IDS['nav_item'] + '_' + innerMainRoute.path"
          >
            <div class="item-container">
              <mat-icon>description</mat-icon>
              <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_nav_item'] + '_' + innerMainRoute.path">
                {{ innerMainRoute.metaData?.navName }}
              </h6>
            </div>
          </mat-list-item>
          } @else if(isGroupedRoute(innerMainRoute)){
          <mat-expansion-panel>
            <mat-expansion-panel-header class="third-level" [attr.data-testid]="ELEMENT_IDS['sec_panel'] + '_' + mainRoute.path + '_' + innerMainRoute.path">
              <mat-panel-title class="menu-item">
                <div class="item-container">
                  <mat-icon>{{ innerMainRoute.metaData?.navIcon }}</mat-icon>
                  <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_panel'] + '_' + mainRoute.path + '_' + innerMainRoute.path">
                    {{ innerMainRoute.metaData.navName }}
                  </h6>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              @for(childRoute of innerMainRoute.children; track childRoute){
              <mat-list-item
                class="menu-item"
                [routerLink]="
                  mainRoute.path +
                  '/' +
                  innerMainRoute.path +
                  '/' +
                  childRoute.path
                "
                routerLinkActive="active-link"
                (click)="toggleDrawer()"
                [attr.data-testid]="ELEMENT_IDS['nav_item'] + '_' + mainRoute.path + '_' + innerMainRoute.path + '_' + childRoute.path"
              >
                <div class="item-container-third-child">
                  <!-- <div class="icon-second-child-container">
                    <mat-icon>circle</mat-icon>
                  </div> -->
                  <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_nav_item'] + '_' + mainRoute.path + '_' + innerMainRoute.path + '_' + childRoute.path">{{ childRoute.metaData.navName }}</h6>
                </div>
              </mat-list-item>
              }
            </mat-nav-list>
          </mat-expansion-panel>
          }
        </mat-nav-list>

        }
      </mat-expansion-panel>
      } }
    </mat-accordion>
  </div>

  <!-- System Related Modules -->
  <!-- NOTE: Will only support single routes for this part, for now. -->
  @if(systemRoutesData && systemRoutesData.length > 0 && systemRoutesData[0]){
    <div class="division">
    <h6 i18n>SYSTEM</h6>
  </div>
  <div class="route-container system-container" [attr.data-testid]="ELEMENT_IDS['cnt_system_menu']">
    <mat-accordion>
      <mat-nav-list>
        @for(mainRoute of systemRoutesData; track mainRoute){
        <!-- Single route -->
        @if(isSingleRoute(mainRoute)){
        <mat-list-item
          [routerLink]="mainRoute.path"
          routerLinkActive="active-link"
          class="menu-item"
          (click)="toggleDrawer()"
          [attr.data-testid]="ELEMENT_IDS['nav_item'] + '_' + mainRoute.path"
        >
          <div class="item-container">
            <mat-icon>{{ mainRoute.metaData?.navIcon }}</mat-icon>
            <h6 class="route-name" [attr.data-testid]="ELEMENT_IDS['lbl_nav_item'] + '_' + mainRoute.path">{{ mainRoute.metaData?.navName }}</h6>
          </div>
        </mat-list-item>
        } }
      </mat-nav-list>
    </mat-accordion>
  </div>
  }
</div>
